import { render, staticRenderFns } from "./UiPaginationOffset.vue?vue&type=template&id=38d98b2d&scoped=true&"
import script from "./UiPaginationOffset.vue?vue&type=script&lang=js&"
export * from "./UiPaginationOffset.vue?vue&type=script&lang=js&"
import style0 from "./UiPaginationOffset.vue?vue&type=style&index=0&id=38d98b2d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38d98b2d",
  null
  
)

export default component.exports